let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aQTX9")).then(() => parcelRequire('aQnRv'));